import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

//
import { showPlanModal } from "../../../redux/features/plan/slice";

//
import { Modal } from "react-bootstrap";

//
import Payment from "./Payment";
import Invoice from "./Invoice";
import Plans from "./plans/Plans";
import CardInfo from "./CardInfo";
import Methods from "./methods/Methods";
import PayByPoints from "./PayByPoints";

function PlanModal({ planModal, showPlanModal }) {
  const modalSize = (step) => {
    if (step === "choose-plan") return "xl";
    if (step === "invoice") return "lg";
    if (step === "choose-method") return "lg";
    if (step === "point") return "lg";
    if (step === "stripe") return "lg";

    return "sm";
  };

  const modalTitle = (step) => {
    if (step === "choose-plan") return <h3>Pricing</h3>;
    if (step === "invoice") return <h5>Invoice</h5>;
    if (step === "choose-method") return <h5>Choose Payment Method</h5>;
    if (step === "stripe") return <h5>Subscribe by Credit Card</h5>;
    if (step === "point") return <h5>Subscribe by Points</h5>;
  };

  const modalSubject = (step) => {
    if (step === "choose-plan")
      return "Choose the right pricing for you and get started with new feature!";
    if (step === "choose-method")
      return "Choose one payment method of 3 options";
    if (step === "stripe")
      return "Please be careful when entering your credit card information";
    if (step === "point")
      return "Complete your purchase by using points";
  };

  return (
    <Modal
      show={planModal.show && planModal.type === 'plan'}
      onHide={() => showPlanModal({ show: false, step: "choose-plan", type:"plan" })}
      size={modalSize(planModal.step)}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      id="plan-modal"
      dialogClassName={planModal.step}
    >
      <Modal.Header closeButton>
        {planModal.step !== "payment" && (
          <>
            {modalTitle(planModal.step)}
            {planModal.step == 'invoice' && <p className="subject">{modalSubject(planModal.step)}</p>}
          </>
        )}
      </Modal.Header>
      <Modal.Body>
        {planModal.step === "choose-plan" && <Plans />}
        
        {planModal.step === "invoice" && <Invoice />}

        {planModal.step === "choose-method" && <Methods />}

        {planModal.step === "point" && <PayByPoints />}

        {planModal.step === "payment" && <Payment />}
      </Modal.Body>
    </Modal>
  );
}

const mapStateToProps = (state) => ({
  planModal: state.planReducer.planModal,
});

const mapDispatchToProps = {
  showPlanModal,
};

PlanModal.propTypes = {
  planModal: PropTypes.object.isRequired,
  showPlanModal: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanModal);
